import * as services from './modules';

export default services;
